module.exports = __webpack_public_path__ + "static/media/lighting.51bdfb28.jpg";